// this is a backport from EXT:bootstrap_package 13.x to get rid of JQuery

window.addEventListener('DOMContentLoaded', function () {

    /*
     * Opt-in, all popovers
     */
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl);
    });

});